import React, { useEffect, useState } from "react";
import { View, Text, Image, TouchableOpacity, StyleSheet } from "react-native";
import { AntDesign } from "@expo/vector-icons";
import { useSelector } from "react-redux";
import { useIsFocused } from "@react-navigation/native";
import CommonModal from "../../../../components/maintainance/CommonModal";
import { navigate } from "../../../../navigation/RootNavigation";
import { TenantService } from "../../redux/tenant.service";

export default function RegisterNewDeposit({ onAddDeposit }) {
    const openFlow = useSelector((state) => state?.tenant.flowIdInfo);

    const [branchIdWraning, setShowbranchIdWraning] = useState(false);
    const [showThirdPartyModal, setShowThirdPartyModal] = useState(false);
    const [showManualActionModal, setShowManualActionModal] = useState(false);

	const schemeName = openFlow?.open_flow_move_in?.open_flow_tenancy_deposit_scheme?.name;
    console.log("schemeName",schemeName)
    const containsTDSNI = typeof schemeName === 'string' && schemeName.toLowerCase().includes('tds ni');
	const containsTDS = typeof schemeName === 'string' && schemeName.toLowerCase().includes('tds');
	const containsSDS = typeof schemeName === 'string' && schemeName.toLowerCase().includes('sds');

	const schemeLogo = 
  containsTDSNI?
  require("./../../../../assets/images/tds3.png"):
	containsTDS	? require("./../../../../assets/images/tds-logo.png")
		: containsSDS 
			? require('./../../../../assets/images/sds.png')
			: require('./../../../../assets/images/sds.png');

      const [tdsAccount, settdsAccount] = useState({
        branch_id: "",
        member_id: "",
        api_key: ""
      });
      const [sdsAccount, setsdsAccount] = useState({
        branch_id: "",
        member_id: "",
        api_key: ""
      });
      const [tdsNiAccount, setTdsNiAccount] = useState({
        branch_id: "",
        member_id: "",
        api_key: ""
      });
      const focused = useIsFocused();

      useEffect(() => {
        FetchData()
      }, [focused]);
      const FetchData =()=>{
        TenantService.getTDSSDSACCOUNT().then((response) => {
          console.log("getTDSSDSACCOUNT",response)
          if(response?.data?.sds?.has_sds_protection){
            setsdsAccount(response?.data?.sds)
          }else{
            setsdsAccount({
              branch_id: "",
              member_id: "",
              api_key: ""
            })
          }
          if(response?.data?.tds?.has_tds_protection){
            settdsAccount(response?.data?.tds)
          }else{
            settdsAccount({
              branch_id: "",
              member_id: "",
              api_key: ""
            })
          }
          if(response?.data?.tds_ni?.has_tds_ni_protection){
            setTdsNiAccount(response?.data?.tds_ni)
          }else{
            setTdsNiAccount({
              branch_id: "",
              member_id: "",
              api_key: ""
            })
          }
        }).catch((err) => {
          console.log("getTDSSDSACCOUNT err",err)
        })
      }

  if(containsTDS||containsSDS||containsTDSNI)
  return (
   
    <View style={styles.card}>
      {/* Title */}
      <Text style={styles.heading}>Register new deposit</Text>
     {schemeName? <Image
          source={schemeLogo}
          style={styles.logo}
        />:null}
      <View style={styles.row}>
        {/* Logo */}
       

        {/* Description */}
        <View style={styles.textBox}>
          <Text style={styles.description}>
            If you have a TDS account you can register your deposit directly
            from tlyfepro. First you must go to the tlyfepro settings section of
            your OpenBrix agent account and add your account information.
            Please click here.
          </Text>

          <Text style={[styles.description, { marginTop: 8 }]}>
            Once account information has been added, simply click “Add Deposit”
            and follow the registration process.
          </Text>
        </View>

        {/* Add Deposit Button */}
        <TouchableOpacity style={styles.button} onPress={() => {
          if (containsTDS && tdsAccount?.branch_id && tdsAccount?.member_id && tdsAccount?.api_key) {
            setShowThirdPartyModal(true);
          } else if (containsSDS && sdsAccount?.branch_id && sdsAccount?.member_id && sdsAccount?.api_key) {
            setShowThirdPartyModal(true);
          } else if (containsTDSNI && tdsNiAccount?.branch_id && tdsNiAccount?.member_id && tdsNiAccount?.api_key) {
            setShowThirdPartyModal(true);
          } else {
            setShowbranchIdWraning(true);
          }
        }}>
          <AntDesign name="plus" size={20} color="#fff" />
          <Text style={styles.buttonText}>ADD DEPOSIT</Text>
        </TouchableOpacity>
      </View>
      <CommonModal
        visible={branchIdWraning}
        heading=""
        subheading={`Please add your Branch ID/Member ID/Api Key to continue.`}
        yesText={"Ok"}
        noText="Cancel"
        onNo={() => setShowbranchIdWraning(false)}
        onYes={() => { setShowbranchIdWraning(false); navigate("HubFlow"); }}
      />

      {/* Third Party Question Modal */}
      <CommonModal
        visible={showThirdPartyModal}
        heading="Is there a third party who has paid this deposit?"
        subheading=""
        yesText="Yes"
        noText="No"
        onNo={() => {
          setShowThirdPartyModal(false);
          onAddDeposit();
        }}
        onYes={() => {
          setShowThirdPartyModal(false);
          setShowManualActionModal(true);
        }}
      />

      {/* Manual Action Required Modal */}
      <CommonModal
        visible={showManualActionModal}
        heading="Manual Action Required"
        subheading={`Please can you login to your TDS account by going to the TDS website and manually add this deposit.`}
        yesText="OK"
        noText=""
        onYes={() => setShowManualActionModal(false)}
        onNo={() => setShowManualActionModal(false)}
      />

    </View>
  );
  else{
    return(
      <></>
    )

  }
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 20,
    shadowColor: "#000",
    shadowOpacity: 0.06,
    shadowOffset: { width: 0, height: 4 },
    shadowRadius: 10,
    elevation: 3,
    marginTop: 10,
    width: "100%",
  },

  heading: {
    fontSize: 18,
    fontWeight: "700",
    color: "#444",

  },

  row: {
    flexDirection: "row",
    alignItems: "flex-start",
  },

  logo: {
    width: 160,
    height: 90,
    resizeMode: "contain",
  
  },

  textBox: {
    flex: 1,
    marginRight: 20,
  },

  description: {
    fontSize: 15,
    color: "#666",
    lineHeight: 22,
  },

  button: {
    backgroundColor: "#A66BFF",
    paddingVertical: 14,
    paddingHorizontal: 18,
    borderRadius: 14,
    flexDirection: "row",
    alignItems: "center",
    shadowColor: "#A66BFF",
    shadowOpacity: 0.25,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 5,
  },

  buttonText: {
    color: "#fff",
    fontSize: 15,
    fontWeight: "600",
    marginLeft: 8,
  },
});
